import type { FC, ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

interface LabelProps {
  value?: string;
  children?: ReactNode;
  className?: string;
  htmlFor?: string;
}

export const Label: FC<LabelProps> = ({ value, children, className = '', htmlFor }) => {
  return (
    <label className={twMerge('block text-sm font-medium text-gray-700', className)} htmlFor={htmlFor}>
      {value || children}
    </label>
  );
};

export default Label;
